<template>
  <!-- 送り状作成シート表示 -->
  <div id="HolterInvoiceSheetView">
    <div id="container">
      <div class="labelTitle lable">送り状シート表示</div>
      <div class="button-area">
        <b-button class="clipboadCopyButton is-primary" @click="clipboardCopy">クリップボードにコピー</b-button>
        <b-button class="backButton is-primary" @click="back">戻る</b-button>
      </div>
      <div class="result-area">
        <b-table
          id="invoiceSheetViewTable"
          :data="data"
          default-sort="user.first_name"
          aria-next-label="Next page"
          aria-previous-label="Previous page"
          aria-page-label="Page"
          aria-current-label="Current page">
          <template slot-scope="props">
            <b-table-column field="receiptNumber" label="受付番号" width="120" centered>{{props.row.receiptNumber }}</b-table-column>
            <b-table-column field="shippingDate" label="出荷予定日" width="80" centered>{{props.row.shippingDate }}</b-table-column>
            <b-table-column label="送り状種類" width="80" centered>0</b-table-column>
            <b-table-column field="deliveryPhoneNumber" label="お届け先電話番号" width="120">{{props.row.deliveryPhoneNumber }}</b-table-column>
            <b-table-column field="deliveryName" label="お届け先名称1" width="300">{{props.row.deliveryName }}</b-table-column>
            <b-table-column field="deliveryZip" label="お届け先郵便番号" width="120" centered>{{props.row.deliveryZip}}</b-table-column>
            <b-table-column field="deliveryAddress1" label="お届け先住所">{{props.row.deliveryAddress1 }}</b-table-column>
            <b-table-column field="deliveryAddress2" label="お届け先建物名（アパートマンション名）">{{props.row.deliveryAddress2 }}</b-table-column>
            <b-table-column label="ご依頼主電話番号" width="120" centered>0120-48-4159</b-table-column>
            <b-table-column label="ご依頼主名" width="200" centered>株式会社フィリップス･ジャパン</b-table-column>
            <b-table-column label="ご依頼主郵便番号" width="120" centered>3500844</b-table-column>
            <b-table-column label="ご依頼主住所" width="160" centered>埼玉県川越市鴨田3453-1</b-table-column>
            <b-table-column label="ご依頼主建物名（アパートマンション名）" width="250">３Ｆ検査検診</b-table-column>
            <b-table-column label="品名１" width="280">検査キット　　　　　　　ﾘﾁｳﾑｲｵﾝﾊﾞｯﾃﾘｰ内蔵</b-table-column>
            <b-table-column label="品名２" width="80" centered></b-table-column>
            <b-table-column label="荷扱い１" width="80" centered>精密機器</b-table-column>
            <b-table-column field="cargoHandling2" label="荷扱い２" width="100" centered>{{props.row.cargoHandling2}}</b-table-column>
            <b-table-column label="記事" width="200"></b-table-column>
            <b-table-column label="お届け予定（指定）日" width="150" centered></b-table-column>
            <b-table-column field="deliveryTimeZone" label="配達時間帯区分" width="120" centered>{{props.row.deliveryTimeZone }}</b-table-column>
            <b-table-column label="個数口枠の印字" width="110" centered>3</b-table-column>
            <b-table-column label="請求先顧客コード" width="120" centered>049229010801</b-table-column>
            <b-table-column label="運賃管理番号" width="100" centered>01</b-table-column>
          </template>
        </b-table>
    　</div>
      <div class="button-area">
        <b-button class="backButton is-primary" @click="back">戻る</b-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HolterInvoiceSheetView",
  methods: {
    back: function () {
      this.$router.push({
        name: "HolterShippingList",
        params: { searchConditions: this.searchParams },
      });
    },
    clipboardCopy: function() {
      var btable = document.getElementById('invoiceSheetViewTable');
      var tableWrapper = btable.getElementsByClassName('table-wrapper')[0];
      var table = tableWrapper.getElementsByTagName('table')[0];
      var tbody = table.getElementsByTagName('tbody')[0];
      navigator.clipboard.writeText(tbody.innerText).then(() => {
        this.showMessage('クリップボードにコピーしました。');
      }).catch(err => {
        this.showMessage('コピーに失敗しました');
      });
    },
    doSearch: function() {
      var excuteApi = this.getHolterInvoiceSheetPOST;
      var successCallBack = this.getHolterInvoiceSheetPOSTSuccess;
      var errorCallBack = this.getHolterInvoiceSheetPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getHolterInvoiceSheetPOST: function(client) {
      return client.apis.internalHolter.getHolterInvoiceSheetPOST({
        body:{receiptNumber:this.receiptNumberList}
      });
    },
    getHolterInvoiceSheetPOSTSuccess: function(result) {
      // 検索結果取得
      this.data = result.obj
      //機器予約時間順に並び変えて表示
      this.data = this.data.sort(function(a, b){
        if(a.reserveTime > b.reserveTime){
          return 1;
        } else {
          return -1;
        }
      })
    },
    getHolterInvoiceSheetPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result,this.back());
    }
  },
  data() {
    var receiptNumberList = this.$route.params["receiptNumberList"];
    var searchParams = this.$route.params["searchConditions"];
    return {
      receiptNumberList,
      data: [],
      searchParams
    };
  },
  async mounted() {
    // 詳細情報取得
    await this.doSearch();
  },
  filters: {},
  components: {}
};
</script>
<style lang="scss" scoped>
.result-area {
  margin-top: 20px;
  width:1400px;
  max-height: 650px;
  overflow: scroll;
}

</style>



// WEBPACK FOOTER //
// src/components/mock/philips/holter/shipping/HolterInvoiceSheetView.vue